import Select, { components } from "react-select";

import axios from "axios";

import { BsChevronDown } from "components/atoms/Icon/bs/BsChevronDown";

import styles from "../Styles.module.scss";

export const DropdownIndicator = ({ ...props }) => {
  return (
    <components.DropdownIndicator {...props}>
      <span className="px-1">
        <BsChevronDown size={13} />
      </span>
    </components.DropdownIndicator>
  );
};

const customStyles = {
  container: (provided) => ({
    ...provided,
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: "30px",
    backgroundColor: "#fff",
    border: "0.5px solid #ddd",
    padding: "0px 16px",
    boxShadow: "none",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#B7B7B7",
    fontSize: "16px",
    fontWeight: "400",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "4px 0px",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: 20,
    overflow: "hidden",
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "8px 16px",
    color: state.isSelected ? "#002A66" : "#333",
    background: state.isSelected || state.isFocused ? "#F1FBFF" : "",
    fontWeight: state.isSelected ? "600" : "normal",
  }),
  input: (provided) => ({
    ...provided,
  }),
  indicatorsContainer: () => ({
    border: "none",
  }),
};

const Component = ({
  countries,
  setForm1Data,
  form1Data,
  setDataBanks,
  errors,
  setErrors,
}) => {
  const { values } = form1Data;
  const getFilteredBanks = async (data, fieldName) => {
    if ((data && fieldName) || (data === "" && fieldName === "businessField")) {
      const newValues =
        form1Data && form1Data.values ? { ...form1Data.values } : {};
      const newDataParams =
        form1Data && form1Data.params ? { ...form1Data.params } : {};

      if (fieldName === "incorporationCountry") {
        newDataParams.incorporation_country_id = data.id;
      }
      if (fieldName === "businessField") {
        newDataParams.business_field = data;
      }
      if (fieldName === "merchantAccount") {
        newDataParams.is_merchant_account = data;
      }
      if (fieldName === "memberNationalities") {
        const newArray =
          data.length > 0 ? `[${data.map((item) => item.id).join(",")}]` : null;

        newDataParams.member_country_ids = newArray;
      }
      if (fieldName === "partnerCountries") {
        const newArray =
          data.length > 0 ? `[${data.map((item) => item.id).join(",")}]` : null;

        newDataParams.partner_country_ids = newArray;
      }
      newValues[fieldName] = data;
      const newForm1Data = {
        values: newValues,
        params: newDataParams,
      };

      setForm1Data(newForm1Data);
      try {
        const response = await axios.get(
          `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/onboarding/banking`,
          { params: newDataParams }
        );

        if (response && response.data && response.data.data) {
          setDataBanks(response.data.data);
          if (response.data.data.length > 0) {
            setErrors({});
          } else {
            const newErrors = { ...errors };
            let errorMessage = "";

            if (fieldName === "incorporationCountry") {
              errorMessage =
                "Sorry, we can not find banks which are matched with your country/jurisdiction, please choose another choices.";
            }
            if (fieldName === "businessField") {
              errorMessage =
                "Sorry, your business activities cannot open bank account as it falls within the general blacklist of most banks.";
            }
            if (fieldName === "merchantAccount") {
              errorMessage =
                "Sorry, we cannot find banks which match your requirement.";
            }
            if (fieldName === "merchantAccount") {
              errorMessage =
                "Sorry, we cannot find banks which match your requirement.";
            }
            if (fieldName === "memberNationalities") {
              errorMessage =
                "Sorry, we found no banks that support your selected nationalities.";
            }
            if (fieldName === "partnerCountries") {
              errorMessage =
                "Sorry, we found no banks that support your selected countries of operation.";
            }
            newErrors[fieldName] = errorMessage;
            setErrors(newErrors);
          }
        }
      } catch (error) {
        console.error();
      }
    }
  };
  const setBusinessField = (e) => {
    setForm1Data({
      ...form1Data,
      values: {
        ...form1Data.values,
        businessField: e.target.value,
      },
    });
  };

  return (
    <>
      <div className="mb-6 lg:mb-10">
        <p className="mb-4 font-medium">
          1. Where was your company incorporated? Or, if you don’t have a
          company yet, what country/jurisdiction do you plan to set up your
          business?
        </p>
        <div className={styles.selectBox}>
          <Select
            instanceId="incorporation-nation"
            placeholder="Choose your country"
            options={countries}
            classNamePrefix="select"
            value={
              values.incorporationCountry ? values.incorporationCountry : ""
            }
            onChange={(value) =>
              getFilteredBanks(value, "incorporationCountry")
            }
            className={styles}
            components={{
              DropdownIndicator,
              IndicatorSeparator: () => null,
            }}
            styles={customStyles}
          />
        </div>
        {errors.incorporationCountry && (
          <div className="my-2 min-h-[21px] text-sm tracking-[0.15px] text-red-500">
            {errors.incorporationCountry}
          </div>
        )}
      </div>
      <div className="mb-6 lg:mb-10">
        <p className="mb-4 font-medium">
          2. Please shortly describe your company&apos;s business activities:
        </p>
        <div>
          <input
            value={values.businessField}
            onChange={setBusinessField}
            onBlur={(e) => getFilteredBanks(e.target.value, "businessField")}
            className="w-full rounded-[30px] border-[0.5px] border-[#ddd] bg-white py-2 px-4 text-base placeholder:font-normal placeholder:text-bbc-neutral-600 focus:outline-bbc-brand-200"
            placeholder="Type business activity"
          />
        </div>
        {errors.businessField && (
          <div className="my-2 min-h-[21px] text-sm tracking-[0.15px] text-red-500">
            {errors.businessField}
          </div>
        )}
      </div>
      <div className="mb-6 lg:mb-10">
        <p className="mb-4 font-medium">
          3. Is a merchant account necessary for your business?
        </p>
        <div className="grid grid-cols-2 gap-x-5">
          <button
            onClick={() => getFilteredBanks("1", "merchantAccount")}
            className={`border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
              values.merchantAccount === "1" ? " bg-bbc-primary text-white" : ""
            }`}
          >
            Yes
          </button>
          <button
            onClick={() => getFilteredBanks("0", "merchantAccount")}
            className={`border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
              values.merchantAccount === "0" ? " bg-bbc-primary text-white" : ""
            }`}
          >
            No
          </button>
        </div>
        {errors.merchantAccount && (
          <div className="my-2 min-h-[21px] text-sm tracking-[0.15px] text-red-500">
            {errors.merchantAccount}
          </div>
        )}
      </div>
      <div className="mb-6 lg:mb-10">
        <p className="mb-4 font-medium">
          4. What are the nationalities of all your company’s members incl.
          directors, shareholders, and beneficial owners?
        </p>
        <div className={styles.selectBox}>
          <Select
            isClearable={false}
            instanceId="members-nation"
            menuPlacement="auto"
            placeholder="Choose nationality"
            options={countries}
            isMulti
            classNamePrefix="select"
            className={`placeholder:font-normal placeholder:text-bbc-neutral-600 ${styles}`}
            components={{
              DropdownIndicator,
              IndicatorSeparator: () => null,
            }}
            styles={customStyles}
            value={values.memberNationalities || []}
            onChange={(value) => getFilteredBanks(value, "memberNationalities")}
          />
        </div>
        {errors.memberNationalities && (
          <div className="my-2 min-h-[21px] text-sm tracking-[0.15px] text-red-500">
            {errors.memberNationalities}
          </div>
        )}
      </div>
      <div className="mb-6 lg:mb-10">
        <p className="mb-4 font-medium">
          5. Where do most of your major partners, suppliers, and customers
          reside?
        </p>
        <div className={styles.selectBox}>
          <Select
            isClearable={false}
            instanceId="members-nation"
            menuPlacement="auto"
            placeholder="Choose nationality"
            options={countries}
            isMulti
            classNamePrefix="select"
            className={`${styles}`}
            components={{
              DropdownIndicator,
              IndicatorSeparator: () => null,
            }}
            styles={customStyles}
            value={values.partnerCountries || []}
            onChange={(value) => getFilteredBanks(value, "partnerCountries")}
          />
        </div>
        {errors.partnerCountries && (
          <div className="my-2 min-h-[21px] text-sm tracking-[0.15px] text-red-500">
            {errors.partnerCountries}
          </div>
        )}
      </div>
    </>
  );
};

export default Component;
